import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/views/Index'
import InputFile from '@/views/InputFile'
import Simulation from '@/views/Simulation'
import Login from '@/views/Login'
import Register from '@/views/Register'
import DocStr from '@/views/docs/DocStr'
import DocOvl from '@/views/docs/DocOvl'
import DocZp from '@/views/docs/DocZp'
import PageNotFound from '@/views/PageNotFound'
import UnitSelection from '@/views/UnitSelection'

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'overview',
    component: HelloWorld
  },
  {
    path: '/register',
    name: 'register',
    component: Register
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/unit',
    name: 'UnitSelection',
    component: UnitSelection
  },
  {
    path: '/file/:type',
    name: 'file',
    component: InputFile
  },
  {
    path: '/simulation',
    name: 'simulation',
    component: Simulation
  },
  {
    path: '/docs/str',
    name: 'docs_str',
    component: DocStr
  },
  {
    path: '/docs/ovl',
    name: 'docs_ovl',
    component: DocOvl
  },
  {
    path: '/docs/zp',
    name: 'docs_zp',
    component: DocZp
  },
  {
    path: '/:catchAll(.*)*',
    name: 'PageNotFound',
    component: PageNotFound
  }
]

const router = new Router({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  // store.dispatch('fetchAccessToken')
  // if (to.fullPath === '/users') {

  if (to.name !== 'login' && !Vue.prototype.$user.isAuthenticated) next({ name: 'login' })
  else next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js